<template lang="html">
  <b-icon :icon="topicIcon"></b-icon>
</template>

<script>
export default {
  props: ['articleTopic'],
  computed: {
    topicIcon () {
      switch (this.articleTopic) {
        case 'Photography':
          return 'camera'
        case 'Posing':
          return 'human-female-dance'
        case 'Make-up':
          return 'lipstick'
        case 'Crafting':
          return 'hammer-wrench'
        case 'Contest':
          return 'medal-outline'
        case 'Convention':
          return 'bank'
        case 'Guest & Pro':
          return 'wizard-hat'
        case 'Body Positivity':
          return 'account-heart'
        case 'Social Networks':
          return 'account-group'
        default:
          return 'infinity'
      }
    }
  }
}
</script>
